export const addAISlashCommand = false;

export function GPTTrigger() {
  return null;
}
